import { IonItem, IonModal, IonTitle, IonButton, IonHeader } from "@ionic/react"
import { useEffect, useState } from "react"
import { API_URL } from "../../../../actions/settings"
import NotificationPopUp from "../../../extras/NotificationPopUp"
import AE2Input from "../../../elements/AE2Input"

interface Props{
    opened:boolean,
    setShowModal:any,
    updateCategories:any,
    edit:any
}

async function addCategory(data:any,token:any) {

    return fetch(`${API_URL}/ae2_eng_unit_categories`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },
      body: JSON.stringify(data)

    })
      .then(data => data.json())
   }

async function editCategory(data:any,token:any) {

    return fetch(`${API_URL}/ae2_eng_unit_categories`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },
      body: JSON.stringify(data)

    })
      .then(data => data.json())
   }



const startForm = {
    'name':"",
    "description": "",
}
const errorsForm:any = {
    'name':"",
    "description": "",
}

const EnergyCategoryForm:React.FC<Props> = ({opened,setShowModal,updateCategories,edit}) =>{
    const [form, setForm] = useState<any>(startForm)
    const [errors, setErrors] = useState(errorsForm)
    const [toEdit,setToEdit] = edit

    useEffect(()=>{
        if(toEdit){
            setForm({
                'id': toEdit['id'],
                'name':toEdit['name'],
                "description": toEdit['description'],
            })
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    },[toEdit])

    const validate = (name:string, val:any) => {
        switch (name) {
            case 'name':
                if(val === null || val.length <1){
                    return {name:'Unit Cannot Be Empty'}
                }
                else{
                    return {name:''}
                }

            default:
                break;
        }
    }

    const validateAll = (form:any) => {
        let validation = errorsForm
        let valid = true
        for (let item in form){

            validation = {...validation, ...validate(item,form[item])}

        }
        setErrors({...errors,...validation})

        for(let val in validation){
            if (validation[val] !== ''){
                valid = false;
            }

        }

        return valid
        }

    const handleFormChange = (value:any,name:string) => {
        setErrors({...errors, ...validate(name,value) })
        setForm((prevState:any) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
    }

    const handleSubmit = async (form:any) => {
        const token:any = localStorage.getItem('token')
        const valid = validateAll(form) || false
        if(valid){
        const res = await addCategory(form,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                setForm(startForm)
                setShowModal(false)
                updateCategories()
                NotificationPopUp('success','Category Added')

            }
            else{
                NotificationPopUp('Error',res.detail||res.ERROR,res.error)
            }
        }
    }

    const handleSubmitEdit = async (form:any) => {
        const token:any = localStorage.getItem('token')
        const valid = validateAll(form) || false
        if(valid){
        const res = await editCategory(form,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                setForm(startForm)
                setShowModal(false)
                updateCategories()
                setToEdit(null)
                NotificationPopUp('success','Category Edited')

            }
            else{
                NotificationPopUp('Error',res.detail||res.ERROR,res.error)
            }
        }
    }


    return (
        <IonModal id="unitsModal" isOpen={opened} onDidDismiss={()=>{setForm(startForm);setShowModal(false);setToEdit(null)}}>
                <IonHeader><IonTitle>{toEdit ? 'Edit Category' : 'Add Category'} </IonTitle></IonHeader>
                    <form>

                        <IonItem>
                            <AE2Input label="Name" labelPlacement="stacked" value={form.name} errorText={errors.name}  placeholder="Name" onIonChange={(e)=> handleFormChange(e.detail.value!,'name')}></AE2Input>
                            {/* <div className="error-detail">{errors.name}</div> */}
                        </IonItem>
                        <IonItem>
                            <AE2Input label="Description" labelPlacement="stacked" errorText={errors.description} value={form.description} placeholder="Description" onIonChange={(e)=> handleFormChange(e.detail.value!,'description')}></AE2Input>
                        </IonItem>

                    </form>
                    <div className='buttons'>
                    { toEdit ?
                    <IonButton onClick={()=>handleSubmitEdit(form)}>Edit</IonButton>
                    : <IonButton onClick={()=>handleSubmit(form)}>Add</IonButton>}

                    <IonButton onClick={()=>setShowModal(false)} color='danger'>cancel</IonButton>
                    </div>
            </IonModal>
    )
}

export default EnergyCategoryForm